import { validateNumber } from 'simple-valley'

export default function dayValidator(v) {
  if (!v.data.day) return v
  return validateNumber(v, 'day', { min: 1, max: 31 })
}